import { Container } from '@tryhackme/thm-ui-components';
import { SimsFaq } from 'src/common/components';
import { businessFaq } from './faq.constants';
export const FAQ = () => {
  return <Container data-sentry-element="Container" data-sentry-component="FAQ" data-sentry-source-file="faq.tsx">
      <SimsFaq faqData={businessFaq} containerMargins={{
      mobile: '4.6rem 1.8rem 0',
      desktop: '11.2rem 1.2rem 0'
    }} data-sentry-element="SimsFaq" data-sentry-source-file="faq.tsx" />
    </Container>;
};